import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'src/redux';

import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { Loader, ReferFriendSignIn } from 'src/components';

import {
  fetchReferrerProfile,
  referFriendSelectors,
} from 'src/redux/referFriend';

import { isStatusIdle, isStatusLoading } from 'src/utils';

export const ReferralRouteGuard: React.FC = () => {
  const dispatch = useAppDispatch();

  const { data, apiStatus } = useAppSelector(
    referFriendSelectors.getReferrerAPIData,
  );

  useEffect(() => {
    if (isStatusIdle(apiStatus)) {
      dispatch(fetchReferrerProfile());
    }
  }, [apiStatus]);

  if (isStatusIdle(apiStatus) || isStatusLoading(apiStatus)) {
    return (
      <Box>
        <Loader />
      </Box>
    );
  }

  if (data) return <Outlet />;

  return <ReferFriendSignIn />;
};
